import {
  PROJECT_ITEM_LIST_DATA_RAW,
  PROJECT_ITEM_LIST_DATA,
} from '../../data/project/constant';

export const MODULE_NAME = 'PROJECT_LIST_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};

export const API = {
  TYPE: 'GET',
  URL: `/project/list`,
};

export interface ACTION_RESPONSE_INTER extends PROJECT_ITEM_LIST_DATA_RAW {}

export interface DATA extends PROJECT_ITEM_LIST_DATA {}

export interface ACTION_ERROR_INTER {
  error: string;
  message: string;
  messages: string[];
  statusCode: string;
}
